import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import axios from "axios";
import { API } from "../../constants/API";
export interface isbnsData {
  _id?: string;
  ISBN?: string;
  FULL_TITLE?: string;
}

export interface OptionType {
  value: string;
  label: string;
}

export interface accountObj {
  _id: string;
  ACCOUNT_NAME: string;
  ACCOUNT_NBR: string;
}

interface account {
  accounts?: accountObj[];
  status?: number;
  message?: string;
  page: number;
  limit: number;
  searchStr: string;
  accountNumberScrollPosition: number;
  isLoading: boolean;
  accountHasMore: boolean;
}

interface newIsbnState {
  accountIsLoading: any;
  message?: string;
  err?: string;
  status?: string;
  selectedISBNS: string[],
  selectedISBNSList: OptionType[],
  selectedTitles: string[],
  selectedTitlesList: OptionType[],
  statusCode: number,
  isbns: isbnsData[];
  isLoading: boolean;
  isbnsString: string;
  isbnsStringForOtis:string
  accounts: account;
  selectedAccountList: OptionType[];
  selectedAccounts: string[];
  isbnSkip: number;
  clickedIsbn: string;
  isbnSkipForOtis: number;
  previousSkip:number;
  isbnLimit: number;
  hasMore: any;
  hasPrevious: any;
  steppingCalled: boolean;
  steppingDirection: string;
  fetchDirection: string;
  Allisbns:any;

}

const initialState: newIsbnState = {
  err: "",
  status: "",
  message: "",
  statusCode: 0,
  isbns: [],
  isbnsString: "",
  isbnsStringForOtis: "",
  selectedISBNS: [],
  selectedAccountList: [],
  selectedAccounts: [],
  selectedISBNSList: [],
  selectedTitles: [],
  selectedTitlesList: [],
  isLoading: false,
  isbnSkip: 0,
  clickedIsbn: "",
  isbnSkipForOtis: 0,
  previousSkip: 0,
  isbnLimit: 15,
  hasMore: '',
  hasPrevious: '',
  steppingCalled: false,
  steppingDirection: '',
  fetchDirection: "",
  accounts: {
    accounts: [],
    isLoading: false,
    status: 0,
    message: "",
    page: 1,
    limit: 10,
    searchStr: "",
    accountNumberScrollPosition: 0,
    accountHasMore: true
  },
  Allisbns: [],
  accountIsLoading: undefined
};

export const fetchIsbnList = createAsyncThunk(
  "isbn/isbn_list",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHISBNSLIST, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
export const fetchAllIsbnLists = createAsyncThunk(
  "fetchAllIsbnLists",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FetchAllIsbnList, data);
      console.log(response, "response.data in fetchIsbnListOnSeason");
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const fetchAccounts = createAsyncThunk(
  "isbn/fetchAccounts",
  async (data: { searchStr?: string, page?: number, limit?: number, oldAccounts?: any, data?: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHACCOUNTS, data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

export const newIsbnSlice = createSlice({
  name: "isbn",
  initialState,
  reducers: {
    updateIsbnSkip: (state) => {
      state.isbnSkip += 1;
    },
    updateIsbnSkipForOtis: (state) => {
      if(state.isbnSkipForOtis < 0){
         state.isbnSkipForOtis = 1;
      }else{
      state.isbnSkipForOtis += 1;

      }
    },
    updateIsbnSkipMinus: (state) => {
      state.isbnSkipForOtis -= 1;
    },

    resetSkip: (state) => {
      state.isbnSkip = 0
state.hasMore=true

    },
    resetSkipForOtis: (state) => {
      state.isbnSkipForOtis = 0


    },
    setSkip: (state, action) => {
      state.isbnSkipForOtis = action.payload;

    },
    setPreviousSkip: (state, action) => {
      state.isbnSkipForOtis = action.payload;

    },
    setClickedIsbn: (state, action) => {
      state.clickedIsbn = action.payload;

    },
    UpdateSelectedISBNS: (state, action) => {
      state.selectedISBNS = action.payload
    },
    UpdateSelectedISBNSList: (state, action) => {
      state.selectedISBNSList = action.payload
    },
    UpdateSelectedTitles: (state, action) => {
      state.selectedTitles = action.payload
    },
    UpdateSelectedTitlesList: (state, action) => {
      state.selectedTitlesList = action.payload
    },
    setIsbnString: (state, action) => {
      if (state.isbns) state.isbnsString = action.payload;
    },
      setIsbnStringForOtis: (state, action) => {
      if (state.isbns) state.isbnsStringForOtis = action.payload;
    },
    updateAccountSearchStr: (state, action) => {
      state.accounts.searchStr = action.payload
    },
    updateAccountPage: (state) => {
      state.accounts.page += 1;
    },
    resetAccountPage: (state) => {
      state.accounts.page = initialState.accounts.page;
    },
    updateScrollPosition: (state, action) => {
      state.accounts.accountNumberScrollPosition = action.payload
    },
    updateSearchStr: (state, action) => {
      state.accounts.searchStr = action.payload;
    },
    emptyAccountsScrollPosition: (state) => {
      state.accounts.accountNumberScrollPosition = initialState.accounts.accountNumberScrollPosition;
    },
    UpdateSelectedAccountList: (state, action) => {
      state.selectedAccountList = action.payload
    },
    UpdateSelectedAccounts: (state, action) => {
      state.selectedAccounts = action.payload
    },
    resetIsbns: (state) => {
      state.isbns = initialState.isbns
    },
    SetSteppingCalled: (state, action) => {
      state.steppingCalled = action.payload
    },
    setSteppingDirection: (state, action) => {
      state.steppingDirection = action.payload
    },
    setFetchDirection: (state, action) => {
      state.fetchDirection = action.payload
    },
    setIsbnState: (state, action) => {
      console.log("seetting",action.payload)
      state.isLoading = action.payload
    }

  },
  extraReducers: (builder) => {

    builder
      .addCase(fetchIsbnList.pending, (state) => {
        state.status = "loading";
        state.isLoading = true;
      })
      // .addCase(fetchIsbnList.fulfilled, (state, action: PayloadAction<any>) => {
      //   state.status = "succeeded";
      //   const filteredISBNs = action.payload.data?.data?.filter(
      //     (isbn: any) =>
      //       !state.isbns
      //         ?.map((stateIsbn) => stateIsbn._id)
      //         .includes(isbn._id)
      //   );
      //   if(action.payload.data.filteredNew){
      //     // alert('iffff')
      //     state.isbns.push(...filteredISBNs)
      //     state.hasMore=action.payload.data?.hasMore
      //     console.log(action.payload.data,'action.payload.data?.data')
      //     // state.isbnSkip = initialState.isbnSkip;
      //   }
      //   else
      //     // alert('else')
      //     action.payload.data?.data?.length &&
      //       state.isbns.push(...filteredISBNs);



      //   state.isLoading=false;

      // })


      .addCase(fetchIsbnList.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "succeeded";
        const newIsbns = action.payload.data?.data || [];

        if (action.payload.data.filteredNew) {
          // Clear old data and set new list for new season/imprint/division
          state.isbns = newIsbns;
        } else {
          // Append only non-duplicate ISBNs
          const filteredISBNs = newIsbns.filter(
            (isbn: any) => !state.isbns?.some((stateIsbn) => stateIsbn._id === isbn._id)
          );
          if (filteredISBNs.length) {
            state.isbns.push(...filteredISBNs);
          }
        }

        state.hasMore = action.payload.data?.hasMore;
        state.hasPrevious = action.payload.data?.hasPrevious
         state.isLoading = false;
      })

      .addCase(fetchIsbnList.rejected, (state, action: PayloadAction<any>) => {
        state.status = "failed";
        state.isLoading = false;
        if (state.isbns) {
          state.statusCode = action.payload.status;
          state.message = action.payload.data?.message ?? "";
        }
      });

    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.accounts.isLoading = true;
      })
      .addCase(fetchAccounts.fulfilled, (state, action: PayloadAction<any>) => {
        state.accounts.isLoading = false;
        state.accounts.accountHasMore = action.payload.data.hasMore;
        const filteredAccounts = action.payload.data?.data?.filter(
          (account: any) =>
            !state.accounts.accounts
              ?.map((stateAccount) => stateAccount._id)
              .includes(account._id)
        );
        if (state.accounts.accounts && state.accounts.page > 1)
          action.payload.data?.data?.length &&
            state.accounts.accounts.push(...filteredAccounts);
        else if (state.accounts.accounts && state.accounts.page === 1)
          // action.payload.data?.data?.length &&
          state.accounts.accounts = filteredAccounts
        state.isLoading = false;
      }
      )
      .addCase(fetchAccounts.rejected, (state, action: PayloadAction<any>) => {
        state.accounts.isLoading = false;
        if (state.accounts) {
          state.accounts.status = action.payload.status;
          state.accounts.message = action.payload.data?.message ?? "";
        }
      })
      .addCase(fetchAllIsbnLists.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllIsbnLists.fulfilled, (state, action: PayloadAction<any>) => {
       state.Allisbns=action.payload.data.data;
         state.hasMore = action.payload.data?.hasMore;
        state.hasPrevious = action.payload.data?.hasPrevious
        state.isLoading = false;
       console.log(action.payload.data,"Seasondata in reducer")
  })
      .addCase(fetchAllIsbnLists.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
      
      });
  },
});

export const {
  resetAccountPage,
  UpdateSelectedISBNSList,
  UpdateSelectedISBNS,
  UpdateSelectedTitlesList,
  UpdateSelectedTitles,
  setIsbnString,
  setIsbnStringForOtis,
  updateAccountSearchStr,
  updateAccountPage,
  updateScrollPosition,
  updateSearchStr,
  resetIsbns,
  SetSteppingCalled,
  setSkip,
  updateIsbnSkipMinus,
  setSteppingDirection,
  updateIsbnSkipForOtis,
  resetSkipForOtis,
  setClickedIsbn,
  setFetchDirection,
  setPreviousSkip,

  emptyAccountsScrollPosition, UpdateSelectedAccountList, UpdateSelectedAccounts,
  updateIsbnSkip, resetSkip,setIsbnState

} = newIsbnSlice.actions;

export const ISBNData = (state: RootState) => state.isbnReducer.isbns;

export default newIsbnSlice.reducer;
